import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

/**
 * Palette primaire du projet = GOLD
 * Basée sur src/styles/abstracts/_colors.scss (gold-50..900)
 */
export const GOLD_PRIMARY = {
  50: '#f6f1eb', // hsl(36, 30%, 95%)
  100: '#efe5de', // hsl(36, 35%, 90%)
  200: '#e3cfb5', // hsl(36, 40%, 80%)
  300: '#d8b88c', // hsl(36, 45%, 70%)
  400: '#c99f68', // hsl(36, 45%, 60%)
  500: '#a67c3f', // hsl(36, 45%, 45%)
  600: '#996f33', // hsl(36, 50%, 40%)
  700: '#865f2d', // hsl(36, 50%, 35%)
  800: '#774f22', // hsl(36, 55%, 30%)
  900: '#664117', // hsl(36, 60%, 25%)
  950: '#4a2f10', // teinte profonde cohérente
} as const;

/**
 * Surfaces claires (chaudes, non gris neutre froid)
 * Inspirées de background/card/secondary/muted/border du thème light
 */
export const WARM_SURFACE_LIGHT = {
  0: '#ffffff',
  50: '#faf9f7',
  100: '#f8f5f0',
  200: '#f2ede6',
  300: '#ebe3d8',
  400: '#d9cec0',
  500: '#b8ab99',
  600: '#8f8172',
  700: '#6c6054',
  800: '#4a4138',
  900: '#2f2924',
  950: '#1f1a17',
} as const;

/**
 * Surfaces sombres (chaudes) basées sur le thème dark du projet
 */
export const WARM_SURFACE_DARK = {
  0: '#ffffff',
  50: '#f7f4ef',
  100: '#e8ddd0',
  200: '#d4c4b0',
  300: '#b89f86',
  400: '#9a7d60',
  500: '#7b5d45',
  600: '#614833',
  700: '#4b3726',
  800: '#36281b',
  900: '#221910',
  950: '#140f0a',
} as const;

export const GoldNoirPreset = definePreset(Aura, {
  semantic: {
    primary: {
      ...GOLD_PRIMARY,
    },
    colorScheme: {
      light: {
        surface: {
          ...WARM_SURFACE_LIGHT,
        },
        primary: {
          color: '{primary.500}', // proche --primary light
          contrastColor: '#ffffff',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}',
        },
        highlight: {
          background: 'color-mix(in srgb, {primary.500}, white 88%)',
          focusBackground: 'color-mix(in srgb, {primary.500}, white 82%)',
          color: '{primary.800}',
          focusColor: '{primary.900}',
        },
      },
      dark: {
        surface: {
          ...WARM_SURFACE_DARK,
        },
        primary: {
          color: '{primary.400}', // comme ton preset d’origine en dark
          contrastColor: '{surface.950}',
          hoverColor: '{primary.300}',
          activeColor: '{primary.200}',
        },
        highlight: {
          background: 'color-mix(in srgb, {primary.400}, transparent 84%)',
          focusBackground: 'color-mix(in srgb, {primary.400}, transparent 76%)',
          color: 'rgba(255,255,255,.92)',
          focusColor: 'rgba(255,255,255,.98)',
        },
      },
    },
  },
});

// Backward-compatible aliases to avoid touching existing imports.
export const CRIMSON_PRIMARY = GOLD_PRIMARY;
export const CRIMSON_SURFACE_LIGHT = WARM_SURFACE_LIGHT;
export const CrimsonNoirPreset = GoldNoirPreset;
